import React, { useState } from 'react';
import TableRow from '../TableRow';
import { Exercise } from '../../../../services/exerciseService';

interface ExerciseTableProps {
    exercises: Exercise[];
    workoutCategories: { id: number; title: string }[];
    workoutPrograms: { id: number; title: string }[];
    targetMuscles: { id: number; name: string }[];
    onEdit: (exercise: Exercise) => void;
    onDelete: (exercise: Exercise) => void;
    onMore: (exercise: Exercise) => void;
}

const ExerciseTable: React.FC<ExerciseTableProps> = ({
    exercises,
    onEdit,
    onDelete,
    onMore
}) => {
    const [expandedRow, setExpandedRow] = useState<number | null>(null);

    return (
        <div className='mt-4'>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white">
                    <thead>
                        <tr className="bg-gray-50">
                            <th className="py-2 px-4 text-left">ID</th>
                            <th className="py-2 px-4 text-left">Name</th>
                            <th className="py-2 px-4 text-left">Categories</th>
                            <th className="py-2 px-4 text-left">Programs</th>
                            <th className="py-2 px-4 text-left">Gender</th>
                            <th className="py-2 px-4 text-left">Fitness Level</th>
                            <th className="py-2 px-4 text-left">Mood</th>
                            <th className="py-2 px-4 text-left">Fitness Goal</th>
                            <th className="py-2 px-4 text-left">Target Muscles</th>
                            <th className="py-2 px-4 text-left">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {exercises.map((exercise) => (
                            <TableRow
                                key={exercise.id}
                                exercise={exercise}
                                expandedRow={expandedRow}
                                onEdit={() => onEdit(exercise)}
                                onDelete={() => onDelete(exercise)}
                                onMore={() => {
                                    setExpandedRow(expandedRow === exercise.id ? null : exercise.id);
                                    onMore(exercise);
                                }}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ExerciseTable;